// src/components/LanguageSelector.jsx
// Language selection screen shown before starting a tour

import { useNavigate } from "react-router-dom";

const STORAGE_KEY = "tib:san-juan:lang";

export default function LanguageSelector({ baseTourId }) {
  const navigate = useNavigate();

  const handleSelect = (lang) => {
    // Remember choice for next time
    localStorage.setItem(STORAGE_KEY, lang);

    // Navigate to the appropriate tour version
    if (lang === "es") {
      navigate(`/tour/${baseTourId}-es`, { replace: true });
    } else {
      navigate(`/tour/${baseTourId}`, { replace: true });
    }
  };

  return (
    <div className="min-h-screen relative overflow-hidden" style={{ background: '#000000' }}>
      <style>{`
        .ios-system-font {
          font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Arial, sans-serif;
        }
      `}</style>

      {/* Hero Image */}
      <div className="absolute inset-0">
        <img
          src="/images/sanjuan.webp"
          alt="San Juan, Puerto Rico"
          className="w-full h-full object-cover object-top"
        />
        {/* Gradient overlay */}
        <div className="absolute inset-0" style={{
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.3) 30%, rgba(0,0,0,0.6) 70%, rgba(0,0,0,0.85) 100%)'
        }}></div>
      </div>

      {/* Back Button */}
      <div className="absolute top-0 left-0 right-0 z-20 flex items-center justify-end p-4 safe-area-inset-top">
        <button
          className="w-10 h-10 rounded-full flex items-center justify-center"
          style={{
            background: 'rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            border: 'none',
            cursor: 'pointer'
          }}
          onClick={() => window.history.back()}
          aria-label="Go back"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round">
            <line x1="2" y1="2" x2="14" y2="14" />
            <line x1="14" y1="2" x2="2" y2="14" />
          </svg>
        </button>
      </div>

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6 text-center">
        {/* Title */}
        <h1 className="ios-system-font text-3xl sm:text-4xl font-bold text-white mb-2">
          San Juan, Puerto Rico
        </h1>
        <p className="ios-system-font text-lg text-white/80 mb-12">
          Cofresí's Treasure Hunt
        </p>

        {/* Language Selection */}
        <div className="w-full max-w-sm">
          <p className="ios-system-font text-sm text-white/70 mb-4 uppercase tracking-wider">
            Choose your language / Elige tu idioma
          </p>

          <div className="space-y-3">
            {/* English Button */}
            <button
              onClick={() => handleSelect("en")}
              className="w-full ios-system-font font-semibold text-base flex items-center justify-center gap-3"
              style={{
                background: '#ffffff',
                color: '#000000',
                borderRadius: '13px',
                padding: '18px',
                border: 'none',
                cursor: 'pointer',
                minHeight: '56px',
                boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3)',
              }}
            >
              <span className="text-xl">🇺🇸</span>
              English
            </button>

            {/* Spanish Button */}
            <button
              onClick={() => handleSelect("es")}
              className="w-full ios-system-font font-semibold text-base flex items-center justify-center gap-3"
              style={{
                background: 'rgba(255, 255, 255, 0.15)',
                backdropFilter: 'blur(20px)',
                WebkitBackdropFilter: 'blur(20px)',
                color: '#ffffff',
                borderRadius: '13px',
                padding: '18px',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                cursor: 'pointer',
                minHeight: '56px',
              }}
            >
              <span className="text-xl">🇵🇷</span>
              Español
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Helper to check if user has a saved language preference
export function getSavedLanguage() {
  return localStorage.getItem(STORAGE_KEY);
}
